import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';

// SESSION-admin-ptg-002 — shared centred modal shell. Wraps the canonical
// `.modal-overlay > .modal` organisms (already in organisms.css; `.modal-wide`
// added this session). Content projects via <ng-content>. Backdrop click + ESC
// emit closeRequest. Consumed by the Add-product modal and (sessions 003/004)
// every other admin modal.
@Component({
    selector: 'app-modal-overlay',
    templateUrl: './modal-overlay.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class ModalOverlayComponent {
    @Input() open = false;
    /** 'default' (460px) | 'wide' (600px) | 'xl' */
    @Input() width: 'default' | 'wide' | 'xl' = 'default';
    /** DESIGN-RULES R7: a form popup sets both to false, so only its Cancel / × closes it. Defaults keep confirm-only dialogs as they were. */
    @Input() closeOnBackdrop = true;
    @Input() closeOnEscape = true;

    @Output() closeRequest = new EventEmitter<void>();

    onBackdrop(event: MouseEvent): void {
        // Only the overlay itself (not the inner modal) closes on click.
        if (this.closeOnBackdrop && event.target === event.currentTarget) {
            this.closeRequest.emit();
        }
    }

    @HostListener('document:keydown.escape')
    onEscape(): void {
        if (this.open && this.closeOnEscape) {
            this.closeRequest.emit();
        }
    }
}
